import React, { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { initRoomStarted, selectRoomStatus } from 'features/room/roomSlice';
import { WaitingScreensProvider } from 'features/waiting-screens';
import RoomContainer from 'features/room/RoomContainer';
import ReconnectionOverlay from 'features/room/components/ReconnectionOverlay';
import RoomLoading from 'features/room/components/RoomLoading';
import { selectShouldShowReconnectOverlay } from 'features/application/applicationSlice';
import { PiPProvider } from 'components/PiP/PiPProvider';

const RoomPage = () => {
  const didInitRef = useRef(false);

  const dispatch = useAppDispatch();

  const roomStatus = useAppSelector(selectRoomStatus);
  const isReconnecting = useAppSelector(selectShouldShowReconnectOverlay);

  useEffect(() => {
    if (!didInitRef.current) {
      didInitRef.current = true;

      const token = new URLSearchParams(window.location.search).get('token');
      const roomId = window.location.pathname.split('/').filter(Boolean)[0];

      // preserve token for development not to reset the app during hot reloading
      if (token && process.env.REACT_APP_PRESERVE_SEARCH_PARAMS !== 'true') {
        window.history.replaceState({}, '', window.location.pathname);
      }

      if (roomId) {
        dispatch(initRoomStarted({ urlId: roomId, token }));
      }
    }

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <>
      <WaitingScreensProvider>
        {roomStatus === 'initializing' || roomStatus === 'duplication-detected' ? (
          <RoomLoading />
        ) : (
          <PiPProvider>
            <RoomContainer />
          </PiPProvider>
        )}
      </WaitingScreensProvider>
      {isReconnecting && <ReconnectionOverlay />}
    </>
  );
};
export default RoomPage;
